"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DeleteEditComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _deleteIcon = _interopRequireDefault(require("../../asset/icons/deleteIcon.svg"));

var _editIcon = _interopRequireDefault(require("../../asset/icons/editIcon.svg"));

require("./DeleteEdit.scss");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DeleteEditComponent = function DeleteEditComponent(props) {
  var deleteCallback = function deleteCallback() {
    if (props["delete"]) {
      props["delete"]();
    }
  };

  var editCallback = function editCallback() {
    if (props.edit) {
      props.edit();
    }
  };

  var editDeleteClass = Object.keys(props).includes('delete') ? 'edit-delete-outer-container' : 'edit-outer-container';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: editDeleteClass
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "edit-container"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    onClick: editCallback,
    className: "edit-button",
    src: _editIcon["default"],
    alt: "edit"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "tip"
  }, "Edit")), Object.keys(props).includes('delete') ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    onClick: deleteCallback,
    className: "delete-button",
    src: _deleteIcon["default"],
    alt: "delete"
  })) : null);
};

exports.DeleteEditComponent = DeleteEditComponent;
var _default = DeleteEditComponent;
exports["default"] = _default;
DeleteEditComponent.propTypes = {
  "delete": _propTypes.func,
  edit: _propTypes.func
};